import type { RegisteredHotkeysT } from '@mentimeter/question-modules-types';

export const HOTKEY_DEBUG = {
  logNativeEvent: true,
  logHotkeysClass: true,
  logHotkeyId: true,
};

export const KEYSTROKES: Array<RegisteredHotkeysT> = [
  'arrowleft',
  'arrowup',
  'arrowdown',
  'arrowright',
  'enter',
  'escape',
  'space',
  's',
];
